// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"af2891f3","143":"2e7329d2","462":"b115a2ad","756":"10f49e3a","767":"72e9a2d9","773":"755407de","900":"d4c6122c","962":"c3a93c8c","999":"05aef4f6"}[chunkId] + ".chunk.js";
};